import React, { useMemo, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import WithOnlyOnDesktop from '../../../components/onlyOnDesktop/withOnlyOnDesktop';
import AgencyProfessionalsCredentialList from './AgencyProfessionalsCredentialList';
import { useEnabledCredentialsQuery } from '../../../redux/external-agency';

import './AgencyProfessionalsCredentials.scss';

const AgencyProfessionalsCredentials = ({ caregiverId }) => {
	const [activeTabIndex, setActiveTabIndex] = useState(0);

	const { data, isFetching, refetch } = useEnabledCredentialsQuery(caregiverId, {
		refetchOnMountOrArgChange: true
	});
	const hasNotSubmittedPL =
		Array.isArray(data) &&
		data?.some((credential) => credential.credential_type === 'PROFESSIONAL_LICENSE' && !credential.submitted.length);

	const multipleLicenseGroups = useMemo(() =>
		new Set(
			((Array.isArray(data) &&
				data?.find((credential) => credential.credential_type === 'PROFESSIONAL_LICENSE'))?.submitted ?? [])
				.map(subItem => subItem?.license_group_id)
		).size > 1, [data]);

	const primaryPracticeArea = useMemo(() =>
		(Array.isArray(data) &&
			data?.find((credential) => credential.credential_type === 'PROFESSIONAL_LICENSE')?.primary_license_group
		), [data])

	return (
		<WithOnlyOnDesktop>
			<div className="credentials">
				<TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
					<TabPanel header="All">
						<AgencyProfessionalsCredentialList
							caregiverId={caregiverId}
							primaryLicense={!isFetching && hasNotSubmittedPL}
							hasMultipleLicenseGroups={!isFetching && multipleLicenseGroups}
							refetchEnabledCredentials={refetch}
							primaryPracticeArea={primaryPracticeArea}
						/>
					</TabPanel>
				</TabView>
			</div>
		</WithOnlyOnDesktop>
	);
};

export default AgencyProfessionalsCredentials;
